<template>
  <v-dialog v-model="dialog" width="800">
    <v-card class="pa-10">
      <v-icon x-large class="v-icon-delete">
        mdi-delete-alert-outline
      </v-icon>

      <div v-if="currentCategoryItem">
        <v-card-title class="text-h6 pp-center">
          Are you sure you want to delete "{{ currentCategoryItem.name }}" category?
        </v-card-title>

        <p class="pp-center pb-5">
          This category will be deleted immediately. You can't undo this action.
        </p>
      </div>

      <div v-else>
        <UnavailableContent />
      </div>

      <Loading v-if="categoryItemLoading"/>

      <ConfirmCancelButtons
          :item="currentCategoryItem"
          :confirm-disabled="categoryItemLoading"
          confirm-text="Delete Category"
          :confirm-action="deleteItemConfirm"
          cancel-class="mr-5"
          :cancel-action="closeDialog"
      />

    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Loading from "@/components/common/Loading";
import ConfirmCancelButtons from "@/components/common/ConfirmCancelButtons";
import UnavailableContent from "@/components/common/UnavailableContent";

export default {
  name: "CategoryDelete",
  components: {UnavailableContent, Loading, ConfirmCancelButtons},
  computed: {
    ...mapState(['currentCategoryItem']),
    ...mapGetters(['categoryApiError', 'openDialog', 'currentCategoryItem', 'categoryItemLoading']),
    dialog: {
      get () {
        return this.openDialog === 'categoryDelete';
      },
      set(value) {
        this.setOpenDialog(value);
      },
    },
  },
  methods: {
    ...mapActions(['deleteCategory', 'clearCategoryItems', 'setOpenDialog', 'closeOpenDialog']),
    closeDialog() {
      this.closeOpenDialog();
      this.clearCategoryItems();
    },
    async deleteItemConfirm() {
      const deleted = await this.deleteCategory(this.currentCategoryItem);
      if (deleted) {
        this.closeOpenDialog();
      }
    },
  },
};
</script>
